export enum EstadoMensaje {
  INITIAL = 0,
  /** Acuse firmado y consolidado en LexNET, pero la notificación aún no se ha descargado. */
  PENDIENTE_DESCARGA = 1,
  DESCARGADO = 2,
  ASIGNADO_EXPEDIENTE = 3,
  FIRMADO_EN_ORIGEN = 4
}

export enum EstadoLexnetMensaje {
  INITIAL = 0,
  PENDIENTE = 1,
  ACEPTADO = 2,
  RECHAZADO = 3,
  SUBSANADO = 5
}
